/* eslint-disable
    func-names,
    no-param-reassign,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

require('./mainapp.scss');

const co = require('co');
require('angular-sanitize');
require('angular-animate');
const printCache = require('app/util/printCache');
const printStates = require('app/util/printStates');

const deps = [
  require('angular-ui-router'),
  require('config').name,
  require('./mainappConfig').name,
  require('./dms').name,
  require('./categorizer').name,
  require('./details').name,
  require('./messaging').name,
  require('./ledgers').name,
  require('./reviewTool').name,
  require('./generalLedger').name,
  require('dev/console').name,
  require('ui/web/base').name,
  require('ui/bk/angularMaterial').name,
  require('data/user').name,
  require('data/model/person').name,
  require('data/service/location').name,
  require('data/model/clientSettings').name,
  require('data/config/hotkeys').name,
  'bench.main-app',
  'ngSanitize',
  'ngMaterial',
];

module.exports = angular
  .module('bench.app.mainapp', deps)

  .config(($stateProvider, MainAppConfig, $logProvider, $compileProvider, config) => {
    $logProvider.debugEnabled(config.ENV === 'dev');

    $compileProvider.debugInfoEnabled(false);

    return $stateProvider.state('bench', {
      abstract: true,
      template: `\
<ui-view></ui-view>
<bl-notifications></bl-notifications>\
`,
      url: '/app/{clientId:[0-9]*}',
      params: {
        clientId: {
          value: MainAppConfig.clientId,
        },
      },
      resolve: {
        _User(User, Person, $stateParams, ClientSettings) {
          return co(function* () {
            yield User.$promise;

            if ($stateParams.clientId != null) {
              User.setClientId($stateParams.clientId);
            }

            const settings = new ClientSettings(User.getClientId());
            yield settings.$promise;

            return User;
          });
        },
      },
    });
  })
  .config((MainAppConfig, $urlMatcherFactoryProvider, $locationProvider) => {
    $urlMatcherFactoryProvider.strictMode(false);
    return $locationProvider.html5Mode({
      enabled: true,
      requireBase: false,
    });
  })
  .config(ngDialogProvider => ngDialogProvider.setDefaults({ appendTo: '[ng-app]' }))
  .run(($rootScope, User, $state) => {
    $state.go('bench.details.card');
    // default to the user's id as the client id in the URL
    return $rootScope.$on(
      '$stateChangeSuccess',
      (event, toState, toParams, fromState, fromParams, error) => {
        if (toParams.clientId === '') {
          return $state.go(toState.name, { clientId: User.userId });
        }
      },
    );
  })
  .run(($rootScope, $window, benchLocation, MainAppConfig, User) => {
    if (MainAppConfig.clientId) {
      User.setClientId(MainAppConfig.clientId);
    }

    return $rootScope.$on('blLoginFailed', () => benchLocation.gotoLogin());
  })
  .run((Store, $window, blConsole, config, $state) => {
    if (config.ENV === 'dev') {
      $window.$printCache = () => printCache(_(Store.$listCache()), blConsole);
      return ($window.$printStates = () => printStates($state.get(), blConsole));
    }
  });
